var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-3 -10 98 102",
    fill: "#383837",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9222 63.4465C44.1187 74.502 23.9133 73.6319 11.1176 60.8361C-2.61179 47.1068 -2.61179 24.8471 11.1176 11.1177C24.847 -2.61166 47.1067 -2.61166 60.836 11.1177C73.6318 23.9134 74.5019 44.1188 63.4465 57.9223L90.2987 84.7745C91.8242 86.3 91.8242 88.7733 90.2987 90.2988C88.7732 91.8243 86.2999 91.8243 84.7744 90.2988L57.9222 63.4465ZM16.6419 55.3119C5.96346 44.6335 5.96346 27.3204 16.6419 16.642C27.3203 5.96358 44.6334 5.96358 55.3118 16.642C65.9823 27.3125 65.9901 44.6081 55.3353 55.2883C55.3274 55.2961 55.3195 55.3039 55.3117 55.3117C55.3038 55.3196 55.296 55.3274 55.2883 55.3353C44.608 65.9903 27.3124 65.9824 16.6419 55.3119Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e51dc1ceeac07a86113e02fff0016af3.svg";
export { ForwardRef as ReactComponent };